import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/app/layouts/error.vue").then(m => m.default || m))
}